import React, { useState, useEffect, useRef } from "react";

import { Row, Col, Input, Button, Alert, Container, Label } from "reactstrap";
import { apiReq } from "../../utils/utils";
import * as url from "../../utils/urls";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import { Link } from "react-router-dom";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";
import EEAA_LOGO from "../../assets/images/eeaa.png";
import Swal from "sweetalert2";

const VerifyPassword = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const history = useHistory();
  const location = useLocation();

  const { token } = queryString.parse(location.search);

  // Verify token for password
  const verifyToken = () => {
    setIsLoading(true);
    apiReq(
      url.VERIFY_MAGIC_LINK,
      {
        token,
      },
      "post",
      {}
    )
      .then((res) => {
        // console.log(res);
        if (res.success) {
          setUserDetails(res.data);
          setIsSuccess(true);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          setIsLoading(false);
          Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.success === false) {
          setIsSuccess(false);
          Swal.fire({
            title: "Error",
            text: err.message,
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  useEffect(() => {
    verifyToken();
  }, [token]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const password = useRef({});
  password.current = watch("password", "");

  const onSubmit = (data) => {
    setIsLoading(true);
    apiReq(
      url.CHANGE_PASSWORD_DIRECT,
      {
        user: userDetails._id,
        password: data.password,
      },
      "post",
      {
        Authorization: `Bearer ${userDetails.token}`,
      }
    )
      .then((res) => {
        console.log(res);
        if (res.success) {
          setIsSuccess(true);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          history.push("/login");
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.apiStatus.statusMessage);
      });
  };

  useEffect(() => {
    document.body.classList.add("auth-body-bg");

    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, []);
  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={8}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={5}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="">
                              <img
                                src={logodark}
                                alt=""
                                height="50"
                                className="auth-logo logo-dark mx-auto"
                              />
                              <img
                                src={logolight}
                                alt=""
                                height="50"
                                className="auth-logo logo-light mx-auto"
                              />
                            </Link>
                          </div>
                          {isSuccess && (
                            <h4 className="font-size-18 mt-4">
                              Hello {userDetails.name}
                            </h4>
                          )}
                          {isSuccess && (
                            <p className="text-muted">
                              Please Enter your new password
                            </p>
                          )}
                        </div>

                        <div className="p-2 mt-5">
                          <form
                            className="form-horizontal"
                            onSubmit={handleSubmit(onSubmit)}
                          >
                            {errors.password && (
                              <div
                                className="alert alert-danger alert-dismissible mb-2"
                                role="alert"
                              >
                                {errors.password.message}
                              </div>
                            )}
                            {errors.confirm_password && (
                              <div
                                className="alert alert-danger alert-dismissible mb-2"
                                role="alert"
                              >
                                {errors.confirm_password.message}
                              </div>
                            )}
                            <div
                              className="mb-4 form-group"
                              style={{ position: "relative" }}
                            >
                              <label>Create New Password</label>
                              <input
                                type="password"
                                className="form-control form-control-lg input-lg"
                                placeholder="Enter your new password"
                                {...register("password", {
                                  required: "You must specify a password",
                                  minLength: {
                                    value: 8,
                                    message:
                                      "Password must have at least 8 characters",
                                  },
                                  pattern: {
                                    value:
                                      /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}/,
                                    message:
                                      "Please use atleast 1 special character, and 1 capital letter in the password.",
                                  },
                                })}
                              />
                            </div>
                            <div
                              className="mb-4 form-group"
                              style={{ position: "relative" }}
                            >
                              <label>Confirm New Password</label>
                              <input
                                type="password"
                                placeholder="Confirm your new password"
                                className="form-control form-control-lg input-lg"
                                {...register("confirm_password", {
                                  validate: (value) =>
                                    value === password.current ||
                                    "The passwords do not match",
                                })}
                              />
                            </div>

                            <div className="mt-4 text-center">
                              {isLoading ? (
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="button"
                                  block
                                  style={{ width: "100%" }}
                                >
                                  Loading...
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="submit"
                                  block
                                  style={{ width: "100%" }}
                                >
                                  Change Password
                                </Button>
                              )}
                            </div>

                            {/* <div className="mt-4 text-center">
                              <Link
                                to="/forgot-password"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock me-1"></i> Forgot
                                your password?
                              </Link>
                            </div> */}
                          </form>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="authentication-bg">
                <div
                  className="login_options d-flex align-items-center"
                  style={{ height: "100%" }}
                >
                  <div className="options_inner">
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center mb-0">Recognized as</p>
                    <p className="text-center">
                      EEAA Best Innovation in Event Tech Winner
                    </p>
                    <div className="login_option_logo_wrapper">
                      <div className="login_option_logo d-flex justify-content-center align-items-center">
                        <img src={EEAA_LOGO} alt={"EEAA_LOGO"} width="200" />
                      </div>
                      <div className="sap_line"></div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center" style={{ fontSize: 18 }}>
                      Recognized by customers across the world as a leader in
                      tech event, online & mobile solutions.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VerifyPassword;
